var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{staticClass:"ma-auto mb-5",attrs:{"src":require("../assets/header.png"),"max-width":"150","max-height":"100"}})
}
var staticRenderFns = []

export { render, staticRenderFns }